import { deeplinkNavigation } from './DeeplinkNavigationParams'

export const navigateHousingLP = (params: { skipLp?: boolean }) => {
  deeplinkNavigation({ name: 'HousingLP', ...params })
}
